import React from 'react';
import ActualizacionMasivaFeeLogistico from "./ActualizacionMasivaFeeLogistico";
import TablaFeeLogistico from "../TablaFeeLogistico";
import NewFee from "../FeeNew";
import TablaFee from "../TablaFee";
import LogisticaPropia from '../../../../Sellers/LogisticaPropia';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import '../../../shared/liquidacionesModule.css';
import LiquidacionesPageHeader from '../../../shared/LiquidacionesPageHeader';
import { LiquidacionesBtnCrear } from '../../../shared/LiquidacionesButtons';
import { LIQUIDACIONES_ROUTES } from '../../../shared/liquidacionesRoutes';

class ActualizacionMasivaLiquidaciones extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabs: [],
      activeFeeTab: 'Fee Activo'
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.seller?.envioPropio && prevProps.seller !== this.props.seller) {
      const tabExists = this.state.tabs.some(tab => tab.name === "Logística Propia");
      if (!tabExists) {
        this.setState((prevState) => ({
          tabs: [
            ...prevState.tabs,
            {
              name: "Logística Propia",
              icon: "ti-home",
              content: <LogisticaPropia idSeller={this.props.idSeller} userType={this.props.userType} />
            }
          ]
        }));
      }
    }
  }

  goToFeeNuevo = () => {
    this.props.navigate('/Liquidaciones/NuevoFee');
  };

  render() {
    const { idSeller, userType } = this.props;
    const feeTabs = [
      {
        key: 'Fee Anterior',
        label: 'Anterior',
        description: 'Consulta histórica'
      },
      {
        key: 'Fee Activo',
        label: 'Activo',
        description: 'Configuración vigente'
      },
      {
        key: 'Fee Próximo',
        label: 'Próximo',
        description: 'Próxima vigencia'
      }
    ];

    return (
      <div className="container gestion-liquidaciones liquidaciones-modulo">
        <LiquidacionesPageHeader
          title="Configuración fee logístico"
          subtitle="Administración de fee anterior, activo y próximo."
          backTo={LIQUIDACIONES_ROUTES.liquidaciones}
          backLabel="Volver"
          showBack
          actions={(
            <LiquidacionesBtnCrear type="button" onClick={this.goToFeeNuevo}>
              Crear fee
            </LiquidacionesBtnCrear>
          )}
        />

          <div className="col-12 mt-2">
            <div className="card shadow-sm border-0">
              <div className="card-body p-3 p-md-4">
                <div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3 mb-4">
                  <div>
                    <h5 className="mb-1 text-dark fw-semibold">Fee logístico por vigencia</h5>
                    <p className="mb-0 text-muted small">Cambiá entre pestañas para revisar o editar cada tramo sin apilar tres tablas en la misma vista.</p>
                  </div>

                  <ul className="nav nav-tabs border-0 gap-2 mb-0" role="tablist" aria-label="Tipos de fee logístico">
                    {feeTabs.map(tab => {
                      const isActive = this.state.activeFeeTab === tab.key;

                      return (
                        <li key={tab.key} className="nav-item" role="presentation">
                          <button
                            type="button"
                            role="tab"
                            aria-selected={isActive}
                            aria-controls={`fee-tab-panel-${tab.key}`}
                            className={`nav-link rounded-top px-3 py-2 ${isActive ? 'active fw-semibold' : 'text-muted'}`}
                            onClick={() => this.setState({ activeFeeTab: tab.key })}
                            style={{
                              minWidth: '140px',
                              border: isActive ? '1px solid #dee2e6' : '1px solid transparent',
                              borderBottom: isActive ? '1px solid #fff' : '1px solid transparent',
                              backgroundColor: isActive ? '#fff' : '#f8f9fa'
                            }}
                          >
                            <div className="fw-semibold">{tab.label}</div>
                            <small className={isActive ? 'text-muted' : 'text-secondary'}>{tab.description}</small>
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </div>

                {feeTabs.map(tab => {
                  const isActive = this.state.activeFeeTab === tab.key;

                  return (
                    <div
                      key={tab.key}
                      id={`fee-tab-panel-${tab.key}`}
                      role="tabpanel"
                      aria-hidden={!isActive}
                      style={{ display: isActive ? 'block' : 'none' }}
                    >
                      <TablaFee idSeller={idSeller} userType={userType} titulo={tab.key} />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  idSeller: state.sellers.currentSellerId,
  userType: state.general.userType,
  seller: state.sellers.seller,
});

const ConnectedComponent = connect(mapStateToProps)(ActualizacionMasivaLiquidaciones);

export default function Wrapper(props) {
  const navigate = useNavigate();
  return <ConnectedComponent {...props} navigate={navigate} />;
}
